/* eslint-disable camelcase */
export default {
  info_popup: 'Additional details',
  link: 'Show on the visual tree',
};
